module.exports = __webpack_public_path__ + "static/media/bgFooterHelp2.6577128e.jpg";